<template>
  <div class="noticePage">
    <!-- <h4>隐私政策</h4> -->
    <h4>
      {{
        pageType == "lzt" ? "林长通" : pageType == "hlt" ? "护林通" : ""
      }}个人信息保护政策
    </h4>
    <p class="pRight">
      <span>本版本发布时间：2021年01月01日</span>
      <span>生效时间：2021年01月01日</span>
    </p>
    <p>
      &ensp;&ensp;&ensp;&ensp;本应用非常重视用户隐私政策并严格遵守相关的法律规定。请您仔细阅读《隐私政策》后再继续使用。如果您继续使用我们的服务，表示您已经充分阅读和理解我们协议的全部内容。本app尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更优质的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。
      您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。
    </p>
    <p>
      <span>1. 适用范围</span>
      (a) 在您注册本应用app帐号时，您根据app要求提供的个人注册信息；
      <br />(b)
      在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
      <br />(c) 本应用通过合法途径从商业伙伴处取得的用户个人数据。
      <br />(d)本应用严禁用户发布不良信息，如裸露、色情和亵渎内容，发布的内容我们会进行审核，一经发现不良信息，会禁用该用户的所有权限，予以封号处理。
      <br />
    </p>
    <p>
      <span>2. 信息使用</span>
      (a)本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人登录信息。如果我们存储发生维修或升级，我们会事先发出推送消息来通知您，请您提前允许本应用消息通知。
      <br />(b)
      本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
      <br />(c)
      本应部分功能需采集相应的位置信息以为您提供相关服务。（例如：正在巡林、上报、工作单上报、护林单上报时都需获取用户实时位置信息），首次登录成功后将提示“允许护林通使用您的位置”，如果您拒绝该项授权，前述功能可能须通过您手动选择位置才能使用。
      <br />(d)
      为确保本应用处于后台运行状态下可正常巡林，本应用须使用（自启动）能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
      <br />
    </p>
    <p>
      <span>3. 信息披露</span>
      在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
      <br />(a) 未经您事先同意，我们不会向第三方披露；
      <br />(b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
      <br />(c)
      根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
      <br />(d)
      如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；
      <br />(e)
      如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
      <br />
    </p>
    <p>
      <span>4. 信息存储和交换</span>
      (a)本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。<br />
      (b)本地保存用户登录信息，录音，视频等功能。
      (c)手机号权限用于用户登录信息。
      <br />
    </p>
    <p></p>
    <p class="sdk">
      <span>5. SDK的使用</span>
      我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。接入第三方SDK目录:<br />
      (1) 百度地图BaiduMapKit，百度地图定位<br />
      &ensp;&ensp;&ensp;使用目的：用于获取本机位置权限,展示地图<br />
      &ensp;&ensp;&ensp;链接地址：<a href="http://lbsyun.baidu.com/index.php"
        >https://lbsyun.baidu.com/index.php</a
      >
      <br />
      (2) TPNS（腾讯）推送<br />
      &ensp;&ensp;&ensp;使用目的：给本机推送消息<br />
      &ensp;&ensp;&ensp;链接地址：<a
        href="https://cloud.tencent.com/act/pro/tpnsnew"
      >
        https://cloud.tencent.com/act/pro/tpnsnew</a
      ><br />
      (3) 阿里云短视频<br />
      &ensp;&ensp;&ensp;使用目的：播放视频<br />
      &ensp;&ensp;&ensp;链接地址:<a
        href="https://help.aliyun.com/document_detail/53847.html"
        >https://help.aliyun.com/document_detail/53847.html</a
      ><br />
      (4) 阿里云音视频通信<br />
      &ensp;&ensp;&ensp;使用目的：实现本机与他机视频通话功能<br />
      &ensp;&ensp;&ensp;链接地址：<a
        href="https://help.aliyun.com/product/61399.html"
        >https://help.aliyun.com/product/61399.html</a
      >
      <br />
      (5) 小米推送<br />
      &ensp;&ensp;&ensp;使用目的:在小米/红米手机上实现消息推送功能
      &ensp;&ensp;&ensp;链接地址:
      <a href="https://dev.mi.com/platform/push"
        >https://dev.mi.com/platform/push</a
      >
      <br />
      (6) OPPO推送<br />
      &ensp;&ensp;&ensp;使用目的:在OPPO及旗下手机实现消息推送功能<br />
      &ensp;&ensp;&ensp;链接地址:
      <a href="https://open.oppomobile.com/opush"
        >https://open.oppomobile.com/opush</a
      >
      <br />
      (6) 讯飞SDk<br />
      &ensp;&ensp;&ensp;使用目的:通过集成SDK方式获取本产品的用户Android ID信息，覆盖本产品的用户并通过SDK集成的方式服务于语音合成功能<br />
      &ensp;&ensp;&ensp;链接地址:
      <a href="https://www.xfyun.cn/doc/tts/online_tts/Android-SDK.html"
        >https://www.xfyun.cn/doc/tts/online_tts/Android-SDK.html</a
      >
      <br />

       
    </p>

    <p>
      <span>6.本隐私政策的概要</span>
      (a) 账号信息<br />
      账户信息是通过平台授权开通方式完成，便于用户登录林相及登录通过林相APP操作相关基础服务功能。账户信息包含头像，姓名、电话、二维码名片、邮箱、个人档案和生日等相关信息，账户登录后支持注销，注销操作后则当天生效;本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。感谢您花时间了解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！
      <br />
      (b) 地理位置<br />
      使用目的：经您授权，我们会收集您的地理位置信息，以便您通过林相完成签到等相关定位服务。<br />信息说明：位置信息的来源包括
      IP 地址、GPS 以及能够提供相关信息的WLAN（如Wi-Fi）
      接入点、蓝牙和基站等传感器信息。您使用服务中提供的信息中可能包含相应地理位置信息，例如您在签到时需要进行地理位置信息。当您拒绝位置授权后仍然可以手动选择或输入位置信息，不会影响您使用其他基本服务。请您知悉，在个别场景下（签到）位置是必要的信息，如果您不同意授权位置信息则可能会影响您的正常使用。
      <br />
      (c) 相册<br />
      使用目的：经您授权，我们会收集您的相册信息，以便为您上传和保存照片、视频等功能。<br />
      信息说明：我们仅在您使用对应功能时收集相应信息，例如您使用上传和保存照片、视频等功能时。不同的系统显示的名称可能有所差异，如相册、存储权限等。
      您可以自行选择开启或关闭相册的授权，一旦关闭您将可能无法通过上传图片、视频等方式来上传头像更换等功能，但不会影响您其他基础服务。
      <br />
      (d) 麦克风<br />
      使用目的：经您授权，我们会收集您的录音信息，以便为您提供用于项目讨论组等语音交互功能。<br />信息说明：我们仅在您使用对应功能时收集相应信息，通过申请麦克风权限以便获得声音，以提供对应的识别后续的交互功能。不同的系统显示的名称可能有所差异，如麦克风、录音权限等。您可以自行选择开启或关闭麦克风授权，一旦关闭您将可能无法使用通过“通讯录打电话”、相关功能，但不会影响其他基本服务。麦克风权限需要您的额外授权，您也可以在系统权限中自主控制，我们绝不会私自开启您的麦克风权限，更不会非法利用非法手段进行相关信息的收集和使用，请您放心。
      <br />
      (e)设备信息<br />
      使用目的：用于APP程序各类异常问题的监察，当发生异常崩溃的情况下会收集到崩溃信息上传到开发者的Bugly账号下，便于开发者对程序出现的错误进行修复，给用户更好的体验，为您提供更好的服务。<br />
      信息说明：在使用腾讯Bugly的SDKApp会搜集手机设备相关信息，主要包括硬件型号、设备MAC地址、唯一设备识别码（如IMEI/MEID/android
      ID/SN/OPENUDID/GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息）、设备型号、设备制造商、操作系统及其版本等
      <br />
      (f) 其他<br />
      本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。感谢您花时间了解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！
      <br />
    </p>
    <p v-if="pageType != ''">
      <span>7. 注销</span>
      (a) 注销功能:{{
        pageType == "lzt"
          ? "我的->注销账号"
          : pageType == "hlt"
          ? "右上角更多->注销"
          : ""
      }}
      <br />
    </p>
    <div class="lianxiMain">
      <p>公司名称：东华（安徽）生态规划院有限公司</p>
      <p>注册地址：安徽省合肥市高新区天智路51号3幢华东中药公司综合楼101室</p>
      <p>
        常用办公地址：安徽省合肥市高新区天智路51号3幢华东中药公司综合楼101室
      </p>
      <p>信息保护负责人：孙其森--13739268593</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "privacyPage",
  data() {
    return {
      pageType: "",
    };
  },
  mounted() {
    document.title = "隐私政策";
    this.pageType =
      this.$route.query.pageType == "" || this.$route.query.pageType == null
        ? ""
        : this.$route.query.pageType;
  },
};
</script>
<style lang="less">
.noticePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 16px 0;
  text-align: justify;

  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    line-height: 25px;
    text-align: center;
    margin-bottom: 10px;
  }
  p {
    font-size: 15px;
    color: #666;
    line-height: 24px;

    span {
      display: block;
      color: #333;
      font-weight: 600;
      line-height: 28px;
    }
    padding-bottom: 10px;
  }
  p.sdk {
    text-align: left;
    overflow: hidden;
  }
  .pRight {
    text-align: right;
  }
  .lianxiMain {
    p {
      padding: 0;
      margin: 5px 0;
    }
  }
}
</style>